"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
const react_1 = __importStar(require("react"));
const icons_1 = require("../icons");
const useDebounce_1 = __importDefault(require("../lib/useDebounce"));
const DEBOUNCE_DELAY = 250;
exports.SearchBar = (props) => {
    const { className, searchTerm, setSearchTerm, } = props;
    const [active, setActive] = react_1.useState(false);
    const [value, setValue] = react_1.useState('');
    react_1.useEffect(() => {
        setValue(searchTerm || '');
    }, []);
    const debounceSearch = useDebounce_1.default(value, DEBOUNCE_DELAY);
    react_1.useEffect(() => {
        setSearchTerm(debounceSearch);
    }, [debounceSearch]);
    const clearInputValue = () => {
        setValue('');
    };
    const handleInput = (inputSearchTerm) => {
        setValue(inputSearchTerm);
    };
    return (react_1.default.createElement("div", { className: `search-bar ${active ? 'active' : ''} ${className}` },
        react_1.default.createElement(icons_1.SearchIcon, null),
        react_1.default.createElement("input", { onChange: (e) => {
                const element = e.target;
                handleInput(element.value);
            }, onBlur: () => setActive(false), onFocus: () => setActive(true), placeholder: "Search", type: "text", value: value }),
        value
            && react_1.default.createElement("button", { className: 'search-bar-clear-button', onClick: clearInputValue },
                react_1.default.createElement(icons_1.ClearIcon, null))));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VhcmNoQmFyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2Zvcm1zL1NlYXJjaEJhci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLCtDQUlpRDtBQUNqRCxvQ0FHb0Q7QUFDcEQscUVBQThEO0FBUTlELE1BQU0sY0FBYyxHQUFHLEdBQUcsQ0FBQztBQUVkLFFBQUEsU0FBUyxHQUFzQyxDQUFDLEtBQXFCLEVBQUUsRUFBRTtJQUNsRixNQUFNLEVBQ0YsU0FBUyxFQUNULFVBQVUsRUFDVixhQUFhLEdBQ2hCLEdBQUcsS0FBSyxDQUFDO0lBRVYsTUFBTSxDQUFFLE1BQU0sRUFBRSxTQUFTLENBQUUsR0FBRyxnQkFBUSxDQUFFLEtBQUssQ0FBQyxDQUFDO0lBQy9DLE1BQU0sQ0FBRSxLQUFLLEVBQUUsUUFBUSxDQUFFLEdBQUssZ0JBQVEsQ0FBRSxFQUFFLENBQUMsQ0FBQztJQUU1QyxpQkFBUyxDQUFFLEdBQUcsRUFBRTtRQUNaLFFBQVEsQ0FBRSxVQUFVLElBQUksRUFBRSxDQUFDLENBQUM7SUFDaEMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBRVAsTUFBTSxjQUFjLEdBQUcscUJBQVcsQ0FBRSxLQUFLLEVBQUUsY0FBYyxDQUFDLENBQUM7SUFFM0QsaUJBQVMsQ0FBRSxHQUFHLEVBQUU7UUFDWixhQUFhLENBQUMsY0FBYyxDQUFDLENBQUM7SUFDbEMsQ0FBQyxFQUFFLENBQUMsY0FBYyxDQUFDLENBQUMsQ0FBQztJQUVyQixNQUFNLGVBQWUsR0FBRyxHQUFHLEVBQUU7UUFDekIsUUFBUSxDQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2xCLENBQUMsQ0FBQztJQUVGLE1BQU0sV0FBVyxHQUFHLENBQUMsZUFBZSxFQUFFLEVBQUU7UUFDcEMsUUFBUSxDQUFFLGVBQWUsQ0FBQyxDQUFDO0lBQy9CLENBQUMsQ0FBQztJQUVGLE9BQU8sQ0FFSCx1Q0FBSyxTQUFTLEVBQUksY0FBYyxNQUFNLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBQSxDQUFDLENBQUMsRUFBRSxJQUFJLFNBQVMsRUFBRTtRQUNoRSw4QkFBQyxrQkFBVSxPQUFHO1FBQ2QseUNBQ0ksUUFBUSxFQUFLLENBQUMsQ0FBQyxFQUFFLEVBQUU7Z0JBQ2YsTUFBTSxPQUFPLEdBQUcsQ0FBQyxDQUFDLE1BQTBCLENBQUM7Z0JBQzdDLFdBQVcsQ0FBRSxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUM7WUFDaEMsQ0FBQyxFQUNELE1BQU0sRUFBVSxHQUFHLEVBQUUsQ0FBQyxTQUFTLENBQUMsS0FBSyxDQUFDLEVBQ3RDLE9BQU8sRUFBUyxHQUFHLEVBQUUsQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLEVBQ3JDLFdBQVcsRUFBRyxRQUFRLEVBQ3RCLElBQUksRUFBVSxNQUFNLEVBQ3BCLEtBQUssRUFBVSxLQUFLLEdBQ3RCO1FBQ0QsS0FBSztlQUNILDBDQUNLLFNBQVMsRUFBRyx5QkFBeUIsRUFDckMsT0FBTyxFQUFPLGVBQWU7Z0JBRTdCLDhCQUFDLGlCQUFTLE9BQUcsQ0FDWixDQUNQLENBQ1QsQ0FBQztBQUNOLENBQUMsQ0FBQyJ9